import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import './Layout.css';
import Header from './components/Header';
import {AdminHeader, SuperAdminHeader} from './components/AdminHeader';
import Footer from './components/Footer';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logout } from '../Actions/Auth';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';

import { checkTimeDifference } from './components/TimeSync';
import { BsInfoCircleFill } from "react-icons/bs";
import Alert from '../BootstrapComponents/Alert';
import CustomerHeader from './components/CustomerHeader';
// import SuperAdminHeader from './components/AdminHeader/SuperAdminHeader';


const ProtectedLayout = (props) => {

  if (props.loading || props.userType == null) {
    if(props.isAuthenticated === false) {
      return (<Navigate to="/login" />)
    }
    return (<div className={'spinner'}><FontAwesomeIcon icon={faBolt} size="3x" /></div>);
  }

  if(props.isAuthenticated && checkTimeDifference()) {
    return (
      <div className={'system-time-error'}>
        <h3><BsInfoCircleFill />System Time Error</h3>
        <p>It looks like your system time is incorrect. Accurate system time is essential for proper functioning of applications and maintaining security.</p>
        <p>After correcting your system time, please reload your application for the changes to take effect.</p>
        <button onClick={() => window.location.reload()}>Reload Application</button>
      </div>
    );
  }
  
  const renderHeader = () => {
    switch (props.userType) {
      case 'User':
        return <Header />;
      case 'Admin':
        return <SuperAdminHeader />;
      case 'Breathe-Admin':
        return <AdminHeader />;
      case 'Customer':
        return <CustomerHeader />;
      default:
        return null;
    }
  };

  return props.isAuthenticated ? (
    <main>
      {renderHeader()}
      <div className='main-container'>
        <Alert/>
        <Outlet />
      </div>
      <Footer />
    </main>
  ) : (
    <Navigate to="/login" />
  );
};

ProtectedLayout.propTypes = {
  isAuthenticated: PropTypes.bool,
  loading: PropTypes.bool,
  userType: PropTypes.string,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading,
  userType: state.auth && state.auth.user ? state.auth.user.type : null,
});

export default connect(mapStateToProps, { logout })(ProtectedLayout);
